var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26651_38567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 0.5H0V16.5H51V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26651_38567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5696 0.5L0 6.3125H1.67678L2.15586 5.14583H4.92144L5.40052 6.3125H7.12085L4.55125 0.5H2.5696ZM3.52776 1.85417L4.37703 3.89583H2.70027L3.52776 1.85417Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27344 6.33464V0.501302H9.64704L11.019 4.2513L12.3691 0.480469H14.7209V6.29297H13.2183V2.04297L11.6287 6.33464H10.3221L8.73244 2.04297V6.33464H7.27344Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7656 6.33333V0.5H20.6435V1.79167H17.29V2.79167H20.5782V4.02083H17.29V5.0625H20.6653V6.33333H15.7656Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5156 0.501302V6.3138H23.0182V4.2513H23.6497L25.4354 6.3138H27.2646L25.3047 4.16797C26.1104 4.10547 26.9379 3.4388 26.9379 2.3763C26.9379 1.14714 25.958 0.480469 24.8474 0.480469L21.5156 0.501302ZM23.0182 1.8138H24.7167C25.1305 1.8138 25.4354 2.1263 25.4354 2.41797C25.4354 2.8138 25.0434 3.02214 24.7385 3.02214H23.0182V1.8138Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0712 6.33333H27.5469V0.5H29.0712V6.33333Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6853 6.33594H32.3586C30.769 6.33594 29.7891 5.10677 29.7891 3.46094C29.7891 1.7526 30.7472 0.523438 32.7506 0.523438H34.4056V1.89844H32.6853C31.8796 1.89844 31.2916 2.52344 31.2916 3.46094C31.2916 4.58594 31.9449 5.0651 32.9031 5.0651H33.295L32.6853 6.33594Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9524 0.5L33.3828 6.3125H35.0596L35.5387 5.14583H38.3042L38.7833 6.3125H40.5037L37.934 0.5H35.9524ZM36.9106 1.85417L37.7598 3.89583H36.0831L36.9106 1.85417Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6348 6.33333V0.5H42.5293L44.9683 4.16667V0.5H46.4708V6.3125H44.6198L42.1373 2.5625V6.3125H40.6348V6.33333Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8887 16.5039V10.6914H15.7666V11.9831H12.3912V12.9831H15.6795V14.2122H12.3912V15.2539H15.7666V16.5247H10.8887V16.5039Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7988 16.5039V10.6914H39.6767V11.9831H36.3014V12.9831H39.5678V14.2122H36.3014V15.2539H39.6767V16.5247H34.7988V16.5039Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9618 16.5039L18.3354 13.6289L15.8965 10.6914H17.7692L19.2282 12.5039L20.6873 10.6914H22.4947L20.0993 13.6081L22.4729 16.5247H20.6001L19.1847 14.7331L17.8128 16.5247L15.9618 16.5039Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6699 10.6914V16.5039H24.216V14.6706H25.7839C27.1123 14.6706 28.1358 13.9831 28.1358 12.6497C28.1358 11.5456 27.3518 10.6914 25.9799 10.6914H22.6699ZM24.1943 12.0039H25.8492C26.2848 12.0039 26.5897 12.2539 26.5897 12.6706C26.5897 13.0664 26.2848 13.3372 25.8492 13.3372H24.1943V12.0039Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7676 10.6914V16.5039H30.2701V14.4414H30.9016L32.6873 16.5039H34.5165L32.5349 14.3789C33.3406 14.3164 34.1681 13.6497 34.1681 12.5872C34.1681 11.3581 33.1881 10.7122 32.0775 10.7122L28.7676 10.6914ZM30.2483 11.9831H31.9469C32.3606 11.9831 32.6655 12.2956 32.6655 12.5872C32.6655 12.9831 32.2736 13.1914 31.9687 13.1914H30.2483V11.9831Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3734 16.5039V15.2539H43.3785C43.8141 15.2539 44.0101 15.0247 44.0101 14.7747C44.0101 14.5247 43.8141 14.2747 43.3785 14.2747H42.0284C40.8525 14.2747 40.1992 13.5872 40.1992 12.5247C40.1992 11.5872 40.809 10.6914 42.5511 10.6914H45.4691L44.8375 12.0039H42.3115C41.8324 12.0039 41.68 12.2539 41.68 12.4831C41.68 12.7331 41.8542 12.9831 42.2244 12.9831H43.6399C44.9464 12.9831 45.5126 13.7122 45.5126 14.6497C45.5126 15.6706 44.8811 16.5039 43.5745 16.5039H40.3734Z",
    fill: "#2970B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8598 16.5039V15.2539H48.8649C49.3004 15.2539 49.4964 15.0247 49.4964 14.7747C49.4964 14.5247 49.3004 14.2747 48.8649 14.2747H47.5148C46.3389 14.2747 45.6855 13.5872 45.6855 12.5247C45.6855 11.5872 46.2953 10.6914 48.0374 10.6914H50.9554L50.3239 12.0039H47.7978C47.3188 12.0039 47.1663 12.2539 47.1663 12.4831C47.1663 12.7331 47.3406 12.9831 47.7108 12.9831H49.1262C50.4328 12.9831 50.999 13.7122 50.999 14.6497C50.999 15.6706 50.3675 16.5039 49.0391 16.5039H45.8598Z",
    fill: "#2970B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american_express.e752bc8554396cfa2672935cb0461e17.svg";
export { ForwardRef as ReactComponent };